<script setup lang="ts">
import useEnvironmentStore from '@/stores/environmentStore'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import PinLogin from '@/components/login/PinLogin.vue'
import EmailLogin from '@/components/login/EmailLogin.vue'
import Tabs, { type TabDescriptor } from '@/components/layout/Tabs.vue'
import type { LoginCredentials } from '@/types'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const router = useRouter()

const env = useEnvironmentStore()
env.title = 'page-titles.login'

const loginEmail: string | undefined = import.meta.env.VITE_LOGIN_EMAIL
const loginPin: string | undefined = import.meta.env.VITE_LOGIN_PIN
const onboardingAvailable: string | undefined = import.meta.env.VITE_ONBOARDING
const logo = '/logo-darkened-300x167.png'

const props = defineProps({
  username: String,
  password: String
})

const username = ref(props.username)
const password = ref(props.password)
function login(credentials: LoginCredentials) {
  env.login(credentials.username, credentials.password).then((result) => {
    if (result) {
      router.push({ name: 'home' })
    }
  })
}

const isEmailLoginEnabled = computed(() => {
  return loginEmail === '1'
})

const isPinLoginEnabled = computed(() => {
  return loginPin === '1'
})

const isOnBoardingEnabled = computed(() => {
  return onboardingAvailable === '1'
})

const descriptors: TabDescriptor[] = [
  { heading: t('tab-label.email'), templateName: 'email' },
  { heading: t('tab-label.pin'), templateName: 'pin' }
]
</script>

<template>
  <div class="logo">
    <img :src="logo" />
  </div>
  <div class="menu-wrapper">
    <div>
      <template v-if="isEmailLoginEnabled && isPinLoginEnabled">
        <Tabs :tabDescriptors="descriptors">
          <template #email>
            <EmailLogin :username="username" :password="password" @do-login="login"></EmailLogin>
          </template>
          <template #pin>
            <PinLogin @do-login="login"></PinLogin>
          </template>
        </Tabs>
      </template>
      <template v-else-if="isEmailLoginEnabled">
        <EmailLogin :username="username" :password="password" @do-login="login"></EmailLogin>
      </template>
      <template v-else-if="isPinLoginEnabled">
        <PinLogin @do-login="login"></PinLogin>
      </template>
    </div>
    <div class="create" v-if="isPinLoginEnabled">
      <span>{{$t('page.login.demo-access')}}</span>
      <RouterLink :to="{name: 'newUser'}">
        <button class="continue">{{$t('page.login.demo-access-request')}}</button>
      </RouterLink>
    </div>

  </div>
  <div v-if="isOnBoardingEnabled">
    <RouterLink :to="{ name: 'onboarding' }">
      <button class="ok">Til onboarding</button>
    </RouterLink>
  </div>
</template>

<style scoped>
.logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 48px;
}

.menu-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 240px;
  gap: 24px;
}
</style>
